import { COLORS } from 'helpers/globals'

export default {
  cameraConfig: {
    flex: '0 0 65%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    background: 'white',
    '&:after': {
      position: 'absolute',
      width: '100%',
      height: '1.5rem',
      bottom: '0',
      content: '""',
      background: 'linear-gradient(to top, rgba(200,200,200, 1), rgba(255,255,255, 0))'
    }
  },
  header: {
    padding: '1rem 2rem',
    minHeight: '5rem',
    fontSize: '1.8rem',
    fontWeight: '400',
    background: COLORS.primary,
    color: 'white'
  },
  editName: {
    display: 'flex',
    alignItems: 'center'
  },
  nameInput: {
    background: 'white !important',
    marginRight: '1rem'
  },
  saveIcon: {
    color: COLORS.ok,
    fontSize: '2.5rem'
  },
  name: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '.2rem',
    paddingLeft: '.6rem'
  },
  editIcon: {
    fontSize: '2rem',
    marginLeft: '1rem'
  },
  body: {
    padding: '1rem 1rem 2rem 1rem',
    color: 'black',
    minHeight: 0,
    overflow: 'auto'
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    color: COLORS.primary,
    fontSize: '2.5rem',
    padding: '.5rem 0'
  },
  deleteButton: {
    color: 'red',
    '& svg': {
      verticalAlign: '-.1rem'
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center'
  },
  modelName: {
    color: COLORS.primary,
    textDecoration: 'underline',
    marginLeft: '.5rem'
  },
  inputs: {
    '& > div': {
      paddingLeft: '.5rem',
      paddingTop: '.5rem',
      '&:nth-child(even)': {
        background: COLORS.tertiary
      }
    },
    '& input, select': {
      background: 'white !important'
    }
  },
  lensContainer: {
    display: 'flex',
    paddingTop: '1rem'
  },
  lensWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '1rem'
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: '300',
    width: '90%',
    justifyContent: 'space-between',
    padding: '.5rem 0',
    '& span': {
      paddingRight: '1rem'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/CameraConfig/style.js